module.exports = __webpack_public_path__ + "static/media/ley.b34d41d2.ogg";